import * as React from 'react';

function SvgSitePin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={34} viewBox="0 0 24 34" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#191829"
          d="M22 0H2a2 2 0 00-2 2v19.152a.5.5 0 00.136.344L11.946 34l11.916-12.504a.5.5 0 00.138-.345V2a2 2 0 00-2-2z"
        />
        <path
          fill="#2F2D78"
          d="M21.5 0h-19a2 2 0 00-2 2v18.158a.5.5 0 00.13.336L11.947 33l11.421-12.506a.5.5 0 00.131-.337V2a2 2 0 00-2-2z"
        />
        <path
          fill="#E2DFFF"
          fillRule="nonzero"
          d="M16.76 10.782V16h-1.958v-5.217l-2.801 2.747-2.803-2.748V16H7.24v-5.217l-2.8 2.746L3 12.116 8.22 7 12 10.706 15.782 7 21 12.116l-1.44 1.412z"
        />
      </g>
    </svg>
  );
}

export default SvgSitePin;
